import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonToolbar,
} from '@ionic/react';
import React from 'react';
import Cookies from 'js-cookie';
import Typography from '../common/Typography';
import { NOTIF_PROMPT } from '../../util/cookie';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import notifImg from '../../images/notif/notif.svg';
import { useFirebase } from '../../services/firebase';
import { LOADING_STATE } from '../../util/loading';
import useUserChannelPreferences from '../../hooks/useUserChannelPreferences';
import useIonicModalProps from '../../hooks/useIonicModalProps';
import {
  COURIER_CASE_NOTIF_PREFERENCE_ID,
  COURIER_MESSAGE_NOTIF_PREFERENCE_ID,
} from '../../util/courier';

interface EnableNotificationsModalProps {
  enabled: boolean;
}

function useEnableNotificationsPrompt(enabled: boolean) {
  const [isOpen, setIsOpen] = React.useState(false);
  const modalProps = useIonicModalProps();
  const { currentUser } = useFirebase();

  const { channelPreferences, loadingState } = useUserChannelPreferences({
    userId: currentUser?.uid,
    templateIds: [
      COURIER_CASE_NOTIF_PREFERENCE_ID,
      COURIER_MESSAGE_NOTIF_PREFERENCE_ID,
    ],
  });

  React.useEffect(() => {
    if (
      !enabled ||
      loadingState !== LOADING_STATE.LOADED ||
      !currentUser?.uid
    ) {
      return;
    }

    let hasAnyNotificationsEnabled = false;
    for (const templateId in channelPreferences) {
      const preferences = channelPreferences[templateId];
      // Only check email and sms
      if (preferences?.email || preferences?.sms) {
        hasAnyNotificationsEnabled = true;
        break;
      }
    }

    // If the user does not have the 'NOTIF_PROMPT' cookie set, open the modal
    const cookieValue = Cookies.get(NOTIF_PROMPT);
    const shouldBePrompted = !cookieValue && !hasAnyNotificationsEnabled;
    if (shouldBePrompted) {
      setIsOpen(true);
      Cookies.set(NOTIF_PROMPT, 'true', { expires: 30 });
    }
  }, [enabled, loadingState]);

  return {
    isOpen,
    onClose: () => {
      setIsOpen(false);
      modalProps.onClose();
    },
    ref: modalProps.ref,
  };
}

const Img = styled.img`
  width: 200px;
  max-width: 100%;
  height: auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
`;

const EnableNotificationsModal: React.FC<EnableNotificationsModalProps> = ({
  enabled,
}) => {
  const modalProps = useEnableNotificationsPrompt(enabled);
  const history = useHistory();
  return (
    <IonModal {...modalProps}>
      <IonHeader>
        <IonToolbar>
          {/* <IonTitle>Enable Notifications?</IonTitle> */}
          <IonButtons slot="end">
            <IonButton onClick={modalProps.onClose}>Close</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Container>
          <Img src={notifImg} alt="Notifications" />

          <Typography margin="32px 0" lineHeight="2em">
            Enable text and email notifications to receive important updates
            such as case reports and messages from your pathologist.
          </Typography>

          <IonButton
            style={{ marginTop: '32px' }}
            onClick={() => {
              modalProps.onClose();

              history.push('/account', {
                open: 'notifications',
              });
            }}
          >
            Go to Notification Settings
          </IonButton>
        </Container>
      </IonContent>
    </IonModal>
  );
};

export default EnableNotificationsModal;
